// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__6YvpP","cell":"ColumnAccessor_cell__QyqWE","firstCellAccent":"ColumnAccessor_firstCellAccent__OOY1V"};